enum BookId {
    GoodGirlKarma = 'Good Girl, Karma',
    TreasuresGift = "Treasure's Gift"
}

export default BookId;
